import {SubmitterMessageCreate, SubmitterMessageResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class SubmitterMessageApi extends CrudApiAbstract<
  SubmitterMessageResource,
  SubmitterMessageCreate
> {
  public constructor() {
    super(`${ResourceType.SubmitterMessage}s`);
  }
}
